export type Mode = 'multiple' | 'single'

export enum SelectSearchEnum {
  Post = 'Post',
  Position = 'Position', // 职务
  Rank = 'Rank', // 职级
  Schedule = 'Schedule', // 部分班次
  Regular = 'Regular', // 规律模板排班
  BankName = 'BankName', // 银行名称
  Contracts = 'Contracts' // 合同公司
}
